import React from "react";

const Customfooter = () => {
  return (
    <React.Fragment>
      <div
        className="copyright-section sticky-bottom footer"
        style={{ background: "#fff",zIndex:'9' }}
      >
        <div className="container-fluid">
          <div className="row">
            <span className="copyright-heading pt-2 pb-2">
              Copyright &copy;2024 &nbsp;
              <a
                href="https://reminiscent.in/"
                target="_blank"
                className="footer_link"
                rel="noreferreer"
              >
                REMINISCENCE LIFESPACE PVT LTD
              </a>
              &nbsp; All rights reserved.
            </span>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Customfooter;
